import { render } from "./Counter.vue?vue&type=template&id=446a0cf4&scoped=true"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=446a0cf4&lang=scss&scoped=true"

import exportComponent from "/Users/wojciechkasprzak/WWW/ilona-michal-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446a0cf4"]])

export default __exports__